var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3606 16.7109C31.3606 7.87438 24.4837 0.710938 16.0006 0.710938C7.51753 0.710938 0.640625 7.87438 0.640625 16.7109C0.640625 25.5475 7.51753 32.7109 16.0006 32.7109C24.4837 32.7109 31.3606 25.5475 31.3606 16.7109Z",
    fill: "url(#paint0_linear_11032_67698)",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 12.7109L19.8402 16.7109L16.0002 20.7109L12.1602 16.7109L16.0002 12.7109Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7212 16.7122C30.7212 8.24387 24.1309 1.37891 16.0012 1.37891C7.87162 1.37891 1.28125 8.24387 1.28125 16.7122C1.28125 25.1806 7.87162 32.0456 16.0012 32.0456C24.1309 32.0456 30.7212 25.1806 30.7212 16.7122Z",
    stroke: "#FCFCFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11032_67698",
    x1: 16.0006,
    y1: 0.710938,
    x2: 16.0006,
    y2: 32.7109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3EEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3EEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shieldIcon.33cf2755f03d7bf76532817cb6be0bb4.svg";
export { ForwardRef as ReactComponent };